const url = typeof location !== 'undefined' ? new URL(location.href) : null;
const qp = (k: string) => url?.searchParams.get(k) ?? null;

export const CONFIG = {
  VERSION: '0.1.0',

  PARTY_HOST: (import.meta.env.VITE_PARTY_HOST as string | undefined) ?? 'localhost:1999',
  PARTY_ROOM: qp('room') ?? 'lobby-1',
  DEV: qp('dev') === '1' || import.meta.env.DEV,
  // MP is the default path — every cold link connects to PartyKit.
  // Solo stub remains available as an offline/juror fallback via
  // `?solo=1`. Flipping the default here forces real MP testing during
  // development and surfaces bugs that the stub would otherwise mask.
  SOLO: qp('solo') === '1',

  // External vibejam webring URL for the Dreamer's Cabin Pieter portal.
  // Override via VITE_PIETER_HUB env or ?hub= query param. 2026 jam
  // requires games to forward visitor identity (username, color, speed,
  // health) — see buildOutboundWebringUrl in portal_inbound.ts.
  PIETER_HUB_URL:
    (import.meta.env.VITE_PIETER_HUB as string | undefined) ??
    qp('hub') ??
    'https://vibejam.cc/portal/2026/',
  // Short slug used as the `ref` query param in the outbound webring
  // URL. Receiving games display this in their welcome banner.
  GAME_SLUG: 'virgin-vs-chad',

  MOVE_SPEED: 6.5,
  SPRINT_MULT: 1.4,
  // Sprint stamina — nonlinear drain so long sprints punish harder than
  // quick bursts. Values in 0..1 fraction of the stamina pool.
  //   Drain: rate = BASE * (1 + (1 - stamina) * CURVE)
  //     → at full stamina: drains in ~1/BASE sec
  //     → near empty:       drains ~2.5× faster (CURVE=1.5)
  //   Regen: fixed rate while NOT sprinting.
  //   Sprint unlocks at UNLOCK (hysteresis vs BLOCK cutoff to avoid
  //   flicker when you bump empty).
  SPRINT_STAMINA_DRAIN: 0.25,
  SPRINT_STAMINA_REGEN: 0.35,
  SPRINT_STAMINA_CURVE: 1.5,
  SPRINT_STAMINA_BLOCK_AT: 0.0,
  SPRINT_STAMINA_UNLOCK_AT: 0.30,
  HOODIE_SPEED_MULT: 0.6,
  HOODIE_DURATION: 4.0,
  HOODIE_COOLDOWN: 15.0,

  ENERGY_MAX: 100,
  CHARISMA_MAX: 100,
  DRAIN_RATE: 10,
  CHARISMA_DRAIN: 5,
  CHARISMA_REGEN: 15,
  CHARISMA_NEIGHBOR_RADIUS: 8,

  TAG_RADIUS: 1.8,
  TETHER_MAX: 5.0,

  SEND_HZ: 20,
  SNAPSHOT_HZ: 15,
  // W17: baseline interp delay. InterpBuffer may temporarily bump
  // this to 120 ms when it detects jitter. See src/net/interp.ts.
  INTERP_BUFFER_MS: 75,

  ROUND_SECONDS: 240,
  LOBBY_SECONDS: 10,
  END_SECONDS: 8,

  TOWN_SEED: 1337,
  TOWN_RADIUS: 90,

  // Perf refactor feature flags. Each tier can be toggled off via URL
  // (?meta=0, ?binary=0, ?delta=0) for live kill-switch if a deploy
  // regresses. Flags that gate wire format MUST stay in lock-step
  // between client and SoloStub — the party server reads client intent
  // from the hello message, not these flags.
  FLAGS: {
    // W1: strip static fields (name/role/hpMax/...) from hot snapshot;
    // server sends playerMeta separately on join/change.
    META_SPLIT: qp('meta') !== '0',
    // W15: binary-quantized HotSnap ArrayBuffer (not yet implemented).
    BINARY_WIRE: qp('binary') === '1',
    // W16: per-connection delta encoding on top of BINARY_WIRE.
    DELTA_WIRE: qp('delta') === '1',
  },
};
